export default "__VITE_ASSET__DJoPd7NG__"